import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e44db526&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e44db526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44db526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e44db526')) {
      api.createRecord('e44db526', component.options)
    } else {
      api.reload('e44db526', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e44db526&scoped=true&", function () {
      api.rerender('e44db526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/need-goods/form/detail.vue"
export default component.exports